const strings = {
  growCropsPage: {
    title: 'Validação',
  },
}

export default strings
